<template>
  <v-dialog v-model="showForm" width="700">
    <template v-slot:activator="{ on, attrs }">
      <v-btn dark text small block v-bind="attrs" v-on="on" class="mb-3" v-if="darkColor"> 
        <v-icon color="warning">mdi-plus</v-icon> Criar uma nota
      </v-btn>

      <v-btn light text small block v-bind="attrs" v-on="on" class="mb-3" v-else>
        <v-icon color="warning">mdi-plus</v-icon> Criar uma nota
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        Nova nota
      </v-card-title>

      <v-divider />

      <v-card-text>
        <v-row dense class="mt-4">
          <v-col v-for="catogory in noteCatogories" :key="catogory.id">
            <v-btn
              block
              small
              :outlined="noteCatogory.id !== catogory.id"
              :color="$Color().colorFor(catogory.color)"
              :dark="$Color().colorText(catogory.color) === $Color().brightText"
              @click="selectCategory(catogory)"
            >
              {{ catogory.name }}
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea 
              v-model="message" 
              v-uppercase
              dense 
              hide-details 
              outlined 
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="clearAndClose">
          cancelar
        </v-btn>

        <v-btn color="primary" text @click="saveNote">
          salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "AddButton",
    props: {
      attendanceId: String,
      refreshList: Function,
      darkColor: Boolean, 
    },
    data() {
      return {
        showForm: false,
        noteCatogories: [],
        noteCatogory: {},
        message: "",
      };
    },
    apollo: {
      noteCatogories: {
        query: require("@/graphql/note/catogories.gql"),
      },
    },
    methods: {
      selectCategory(noteCatogory) {
        this.noteCatogory = noteCatogory;
      },
      clearAndClose() {
        this.noteCatogory = {};
        this.message = "";

        this.showForm = false;
      },
      saveNote() {
        this.apolloMutate({
          mutation: require("@/graphql/note/save_note.gql"),
          variables: {
            attendanceId: this.attendanceId,
            noteCategoryId: this.noteCatogory.id,
            message: this.message,
          },
        }).then(() => {
          this.clearAndClose();
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
